"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DoneAll_exports = {};
__export(DoneAll_exports, {
  default: () => DoneAll_default
});
module.exports = __toCommonJS(DoneAll_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.3672 7.125C14.5104 7.26823 14.5755 7.4375 14.5625 7.63281C14.5625 7.8151 14.4974 7.97786 14.3672 8.12109L10.9688 11.5977C10.8385 11.7279 10.6758 11.793 10.4805 11.793C10.2852 11.793 10.1224 11.7279 9.99219 11.5977C9.86198 11.4544 9.79688 11.2852 9.79688 11.0898C9.79688 10.8945 9.86198 10.7318 9.99219 10.6016L13.3906 7.125C13.5339 6.98177 13.6966 6.91016 13.8789 6.91016C14.0742 6.91016 14.237 6.98177 14.3672 7.125ZM3.19531 12.6328C3.0651 12.4896 3 12.3268 3 12.1445C3 11.9492 3.0651 11.7799 3.19531 11.6367C3.33854 11.5065 3.5013 11.4414 3.68359 11.4414C3.87891 11.4414 4.04167 11.5065 4.17188 11.6367L7.0625 14.5859C7.19271 14.7292 7.25781 14.8984 7.25781 15.0938C7.25781 15.2891 7.19271 15.4518 7.0625 15.582C6.91927 15.7253 6.75 15.7969 6.55469 15.7969C6.3724 15.7969 6.21615 15.7253 6.08594 15.582L3.19531 12.6328ZM7.84375 11.5781L10.3633 14.1758L16.6914 7.65234C16.8477 7.49609 17.0299 7.41797 17.2383 7.41797C17.4466 7.41797 17.6289 7.49609 17.7852 7.65234C17.9284 7.79557 18 7.97786 18 8.19922C18 8.42057 17.9284 8.60938 17.7852 8.76562L10.8906 15.8555C10.7474 16.0117 10.5651 16.0898 10.3438 16.0898C10.1354 16.0898 9.95964 16.0117 9.81641 15.8555L6.75 12.6914C6.60677 12.5482 6.53516 12.3659 6.53516 12.1445C6.53516 11.9232 6.60677 11.7344 6.75 11.5781C6.90625 11.4349 7.08854 11.3633 7.29688 11.3633C7.50521 11.3633 7.6875 11.4349 7.84375 11.5781Z",
      fill: "currentColor"
    }
  )
);
const SvgDoneAll = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DoneAll_default = SvgDoneAll;
